import Emitter from "../../../../_snowpack/pkg/tiny-emitter.js";

export default new Emitter();
